'use strict';

var React = require('react');

var SvgInactiveLocationMinor = function SvgInactiveLocationMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.34 3.888a6.591 6.591 0 0 0-3.34-.888c-3.314 0-6 2.35-6 5.25 0 1.481.398 2.823.992 3.986l1.125-1.126a7.111 7.111 0 0 1-.617-2.86c0-1.89 1.82-3.75 4.5-3.75.84 0 1.595.183 2.236.492l1.104-1.104Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.845 6.382a2.75 2.75 0 0 0-3.463 3.463l3.463-3.463Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.086 15.264a.75.75 0 0 0 1.066 1.055l1.593-1.594c1.341 1.45 2.77 2.275 3.255 2.275 1 0 6-3.5 6-8.75 0-.793-.2-1.545-.56-2.219l1.379-1.38a.75.75 0 1 0-1.06-1.06l-11.668 11.667-.005.006Zm10.414-7.014c0 2.136-1.02 3.982-2.241 5.342a9.67 9.67 0 0 1-1.737 1.535 4.805 4.805 0 0 1-.522.31 4.816 4.816 0 0 1-.522-.31 9.613 9.613 0 0 1-1.671-1.463l6.495-6.496c.13.351.198.716.198 1.082Zm-4.688 7.27a.064.064 0 0 0-.006.001l.006-.001Zm.381.001h.002-.002Z"
  }));
};
SvgInactiveLocationMinor.displayName = "InactiveLocationMinor";

exports.SvgInactiveLocationMinor = SvgInactiveLocationMinor;
